<template>
  <div
    v-if="richText"
    :class="$style.root"
  >
    <CoreTextComponent :string="richText" />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
    richText: string
  }>()
</script>

<style module>
.root {
  composes: font-size-small font-helvetica from global;

  --block--margin-top: calc(var(--unit--vertical) * 2);
  --block--margin-bottom: calc(var(--unit--vertical) * 2);

  padding: var(--padding--element);
  padding-left: var(--unit--default);
  padding-right: var(--unit--default);
}

.root * {
  font-weight: normal !important;
}
</style>
